import { Send } from "lucide-react";

export function TelegramTab({
  telegramConfigured, telegramInfo, blastLimit, setBlastLimit, blasting, onBlast, sched, setSched, onSaveSchedule,
  weeklyCardUrl, onWeeklyPreview, onWeeklySend,
  statusCardUrl, statusDate, setStatusDate, onStatusPreview, onStatusSend,
  onAlertTest,
}) {
  return (
    <div data-testid="admin-telegram-panel" className="max-w-xl">
      {telegramConfigured ? (
        <div className="space-y-6 border border-white/10 bg-black/40 p-8">
          {telegramInfo && (
            <div data-testid="telegram-channel-card" className="flex items-center justify-between border border-[#229ED9]/30 bg-[#229ED9]/5 px-6 py-4">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Channel</p>
                <p data-testid="telegram-channel-name" className="text-sm font-semibold text-white">
                  {telegramInfo.chat_title || "Telegram Channel"}
                  {telegramInfo.username && (
                    <span className="ml-2 text-[#229ED9]">@{telegramInfo.username}</span>
                  )}
                </p>
              </div>
              <div className="text-right">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Members</p>
                <p data-testid="telegram-member-count" className="text-2xl font-bold text-[#FFD700]">
                  {telegramInfo.member_count != null ? telegramInfo.member_count.toLocaleString() : "—"}
                </p>
              </div>
            </div>
          )}
          <p className="text-sm text-[#A1A1A6]">
            Send the latest charts as photos to your Telegram channel.
          </p>
          <div>
            <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">
              Number of latest charts
            </p>
            <input
              data-testid="blast-limit-input"
              type="number"
              min="1"
              max="50"
              value={blastLimit}
              onChange={(e) => setBlastLimit(e.target.value)}
              className="w-32 border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-[#FFD700]/60"
            />
          </div>
          <button
            data-testid="telegram-blast-btn"
            onClick={onBlast}
            disabled={blasting}
            className="flex items-center gap-2 rounded-full bg-[#229ED9] px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] text-white transition-transform duration-300 hover:scale-105 disabled:opacity-50"
          >
            <Send className="h-4 w-4" /> {blasting ? "Blasting..." : "Blast to Telegram"}
          </button>

          <div data-testid="telegram-schedule-card" className="mt-8 space-y-5 border-t border-white/10 pt-6">
            <p className="text-sm font-semibold text-white">Daily auto-blast</p>
            <p className="text-xs leading-relaxed text-[#A1A1A6]">
              ஒவ்வொரு நாளும் இந்த நேரத்துக்கு (IST) எல்லா charts-ம் channel-க்கு தானா போகும் — நீங்க எதுவும் தொட வேண்டாம்.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <button
                data-testid="schedule-toggle"
                onClick={() => setSched({ ...sched, enabled: !sched.enabled })}
                className={`rounded-full px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
                  sched.enabled ? "bg-[#00E676] text-black" : "border border-white/15 text-[#A1A1A6]"
                }`}
              >
                {sched.enabled ? "ON" : "OFF"}
              </button>
              <input
                data-testid="schedule-time-input"
                type="time"
                value={sched.time}
                onChange={(e) => setSched({ ...sched, time: e.target.value })}
                className="border border-white/10 bg-black px-4 py-2 font-mono text-sm text-white outline-none focus:border-[#FFD700]/60 [color-scheme:dark]"
              />
              <button
                data-testid="schedule-save-btn"
                onClick={onSaveSchedule}
                className="rounded-full bg-[#FFD700] px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-black transition-transform duration-300 hover:scale-105"
              >
                Save
              </button>
            </div>
            {sched.last_blast && (
              <p data-testid="schedule-last-blast" className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">
                Last auto-blast: {sched.last_blast} · {sched.last_sent || 0} charts
              </p>
            )}
          </div>

          <div data-testid="telegram-digest-card" className="space-y-5 border-t border-white/10 pt-6">
            <p className="text-sm font-semibold text-white">Daily chart digest</p>
            <p className="text-xs leading-relaxed text-[#A1A1A6]">
              ஒவ்வொரு காலையும் இந்த நேரத்துக்கு (IST) நேற்று எந்தந்த charts update ஆயின என்ற summary message channel-க்கு தானா போகும்.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <button
                data-testid="digest-toggle"
                onClick={() => setSched({ ...sched, digest_enabled: !sched.digest_enabled })}
                className={`rounded-full px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
                  sched.digest_enabled ? "bg-[#00E676] text-black" : "border border-white/15 text-[#A1A1A6]"
                }`}
              >
                {sched.digest_enabled ? "ON" : "OFF"}
              </button>
              <input
                data-testid="digest-time-input"
                type="time"
                value={sched.digest_time || "09:30"}
                onChange={(e) => setSched({ ...sched, digest_time: e.target.value })}
                className="border border-white/10 bg-black px-4 py-2 font-mono text-sm text-white outline-none focus:border-[#FFD700]/60 [color-scheme:dark]"
              />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">Save மேலே உள்ள Save button-இல்</span>
            </div>
          </div>
          <div data-testid="telegram-weekly-card" className="space-y-5 border-t border-white/10 pt-6">
            <p className="text-sm font-semibold text-white">Weekly summary card (ஞாயிறு)</p>
            <p className="text-xs leading-relaxed text-[#A1A1A6]">
              ஒவ்வொரு ஞாயிறு இரவும் (IST) அந்த வாரத்தின் முழு result-சுருக்கம் ஒரே branded image-ஆக channel-க்கு தானா போகும்.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <button
                data-testid="weekly-toggle"
                onClick={() => setSched({ ...sched, weekly_enabled: !sched.weekly_enabled })}
                className={`rounded-full px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
                  sched.weekly_enabled !== false ? "bg-[#00E676] text-black" : "border border-white/15 text-[#A1A1A6]"
                }`}
              >
                {sched.weekly_enabled !== false ? "ON" : "OFF"}
              </button>
              <input
                data-testid="weekly-time-input"
                type="time"
                value={sched.weekly_time || "21:30"}
                onChange={(e) => setSched({ ...sched, weekly_time: e.target.value })}
                className="border border-white/10 bg-black px-4 py-2 font-mono text-sm text-white outline-none focus:border-[#FFD700]/60 [color-scheme:dark]"
              />
              <button
                data-testid="weekly-preview-btn"
                onClick={onWeeklyPreview}
                className="rounded-full border border-[#FFD700]/50 px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#FFD700] transition-colors duration-300 hover:bg-[#FFD700]/10"
              >
                Preview card
              </button>
            </div>
            {weeklyCardUrl && (
              <div className="space-y-3">
                <img
                  data-testid="weekly-card-image"
                  src={`${process.env.REACT_APP_BACKEND_URL}${weeklyCardUrl}`}
                  alt="Weekly summary card"
                  className="max-w-md border border-white/10"
                />
                <button
                  data-testid="weekly-send-btn"
                  onClick={onWeeklySend}
                  className="rounded-full bg-[#229ED9] px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-white transition-transform duration-300 hover:scale-105"
                >
                  Send to channel now
                </button>
              </div>
            )}
          </div>
          <div data-testid="telegram-alerts" className="space-y-4 border-t border-white/10 pt-6">
            <p className="text-sm font-semibold text-white">Pre-result alerts (auto)</p>
            <p className="text-xs leading-relaxed text-[#A1A1A6]">
              ஒவ்வொரு draw-க்கும் 2 நிமிடம் முன், அந்த draw-இன் தற்போதைய chart image-உடன் alert தானாக channel-க்கு போகும்
              (10:58, 11:58, 12:58, 14:58, 16:58, 17:58, 18:58, 19:58 IST) — link எப்போதும் goldenraja.in மட்டுமே.
            </p>
            <button
              data-testid="alert-test-btn"
              onClick={onAlertTest}
              className="rounded-full border border-[#229ED9]/50 px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#229ED9] transition-colors duration-300 hover:bg-[#229ED9]/10"
            >
              Send test alert
            </button>
          </div>
          <div data-testid="telegram-status-card" className="space-y-5 border-t border-white/10 pt-6">
            <p className="text-sm font-semibold text-white">Status story card (தினசரி)</p>
            <p className="text-xs leading-relaxed text-[#A1A1A6]">
              தினமும் Dear 8PM result உள்ளதும் அன்றைய எல்லா results-ம் ஒரே vertical story image-ஆக (1080×1920)
              தானாக உருவாகி channel-க்கு post ஆகும். கீழே எந்த நாளுக்கும் manual-ஆகவும் உருவாக்கலாம்.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <input
                data-testid="status-date-input"
                type="date"
                value={statusDate}
                onChange={(e) => setStatusDate(e.target.value)}
                className="border border-white/10 bg-black px-4 py-2 font-mono text-sm text-white outline-none focus:border-[#FFD700]/60 [color-scheme:dark]"
              />
              <button
                data-testid="status-preview-btn"
                onClick={onStatusPreview}
                className="rounded-full border border-[#FFD700]/50 px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#FFD700] transition-colors duration-300 hover:bg-[#FFD700]/10"
              >
                Preview card
              </button>
            </div>
            {statusCardUrl && (
              <div className="space-y-3">
                <img
                  data-testid="status-card-image"
                  src={`${process.env.REACT_APP_BACKEND_URL}${statusCardUrl}`}
                  alt="Daily status story card"
                  className="max-w-xs border border-white/10"
                />
                <button
                  data-testid="status-send-btn"
                  onClick={onStatusSend}
                  className="rounded-full bg-[#229ED9] px-6 py-2 text-xs font-bold uppercase tracking-[0.12em] text-white transition-transform duration-300 hover:scale-105"
                >
                  Send to channel now
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div data-testid="telegram-not-configured" className="border border-dashed border-[#229ED9]/40 bg-black/40 p-8">
          <p className="mb-3 text-sm font-semibold text-white">Telegram auto-blast not configured yet</p>
          <p className="text-sm leading-relaxed text-[#A1A1A6]">
            Create a bot via <span className="font-mono text-[#229ED9]">@BotFather</span> on Telegram, add it as
            admin to your channel, then set <span className="font-mono">TELEGRAM_BOT_TOKEN</span> and{" "}
            <span className="font-mono">TELEGRAM_CHANNEL_ID</span> in the backend environment and restart.
          </p>
        </div>
      )}
    </div>
  );
}
